/**
 * Обёртка над внешним трекером rpTracker (public/shared/rptracker.js).
 * Скрипт подключается плагином ~/plugins/snowplow.ts и доступен только в браузере,
 * поэтому все вызовы защищены проверкой наличия window.rpTracker.
 */
export const useSnowplow = () => {
  const trackSelfDescribingEvent = (
    eventCategory: string,
    eventAction: string,
    eventValueText = '',
    eventJSON = '',
    eventEmail = '',
  ) => {
    if (!import.meta.client || !window.rpTracker) return

    window.rpTracker.trackSelfDescribingEvent(
      eventCategory,
      eventAction,
      eventValueText,
      eventJSON,
      eventEmail,
    )
  }

  return { trackSelfDescribingEvent }
}
